// 设备校准证书专用处理逻辑
import { postFormData } from './apiClient';
import { STEP } from './workflowConfig';
import { mergeBatchResultItems, normalizeSingleResultTables } from './tableNormalization';

export const DIRECTION_MAP = { horizontal: '水平', vertical: '垂直', h: '水平', v: '垂直' };
export const ELECTROMAGNETIC_MAP = { magnetic: '磁场', electric: '电场' };
export const DEVICE_TYPES = [
  {
    value: 'preamplifier',
    label: '有源放大器',
    desc: '增益',
    chart: { x: 'Frequency[MHz]', y: 'Factor[dB]', title: '增益-频率曲线' }
  },
  {
    value: 'aimn',
    label: '人工电源网络',
    desc: '电压分压系数',
    chart: { x: 'Frequency[MHz]', y: 'Factor[dB]', title: '分压系数-频率曲线' }
  },
  {
    value: 'pulse_limiter',
    label: '同轴线缆/衰减器',
    desc: '插入损耗',
    chart: { x: 'Frequency[MHz]', y: 'Factor[dB]', title: '插入损耗-频率曲线' }
  },
  {
    value: 'receiving_antenna',
    label: '接收天线',
    desc: '天线系数',
    chart: { x: 'Frequency[MHz]', y: 'Factor[dB]', title: '天线系数-频率曲线' }
  },
  {
    value: 'probe',
    label: '探头',
    desc: '转移阻抗、分压系数、频率响应',
    chart: { x: '频率[MHz]', y: '校准因子', title: '校正因子-频率曲线' }
  }
];

// 初始化设备处理流程的通用加载状态。
const beginProcessing = (setLoading, setError, setTables) => {
  setLoading(true);
  setError('');
  setTables([]);
};

// 统一设备处理异常文案并回退到上传步骤。
const handleProcessError = (err, setError, setCurrentStep, logPrefix) => {
  console.error(logPrefix, err);
  setError(`处理失败: ${err.message || '未知错误'}`);
  setCurrentStep(STEP.UPLOAD);
};

export const handleDeviceTypeSelect = (type, setDeviceType, setCurrentStep) => {
  // 选择设备类型并进入上传步骤。
  setDeviceType(type);
  setCurrentStep(STEP.UPLOAD);
};

export const handleProcessDeviceCalibration = async (
  file,
  deviceType,
  setLoading,
  setError,
  setTables,
  setCurrentStep
) => {
  // 提交单个设备文件并读取校准结果。
  if (!file || !deviceType) {
    setError('请先选择文件和设备类型');
    return;
  }
  beginProcessing(setLoading, setError, setTables);

  const formData = new FormData();
  formData.append('file', file);
  formData.append('device_type', deviceType);

  try {
    const { response, data } = await postFormData('/api/process-device-calibration', formData);

    if (!response.ok || !data?.success) {
      throw new Error(data?.error || '设备校准数据处理失败');
    }

    const normalizedTables = normalizeSingleResultTables(data?.result);

    setTables(normalizedTables);
    setCurrentStep(STEP.RESULTS);
  } catch (err) {
    handleProcessError(err, setError, setCurrentStep, '处理设备校准数据时出错:');
  } finally {
    setLoading(false);
  }
};
export const handleProcessDeviceCalibrationBatch = async (
  files,
  deviceType,
  setLoading,
  setError,
  setTables,
  setCurrentStep
) => {
  // 提交批量设备文件并合并展示表格结果。
  const normalizedFiles = Array.isArray(files) ? files.filter(Boolean) : [];
  if (!normalizedFiles.length || !deviceType) {
    setError('请先选择文件和设备类型');
    return;
  }
  beginProcessing(setLoading, setError, setTables);
  const formData = new FormData();
  normalizedFiles.forEach((file) => formData.append('files', file));
  formData.append('device_type', deviceType);

  try {
    const { response, data } = await postFormData('/api/process-device-calibration/batch', formData);
    if (!response.ok || !data?.success) {
      throw new Error(data?.error || '设备校准批量处理失败');
    }

    const mergedTables = mergeBatchResultItems(data?.result?.items);

    if (!mergedTables.length) {
      throw new Error('批量处理完成，但没有可展示的表格数据');
    }

    setTables(mergedTables);
    setCurrentStep(STEP.RESULTS);
  } catch (err) {
    handleProcessError(err, setError, setCurrentStep, '批量处理设备校准数据时出错:');
  } finally {
    setLoading(false);
  }
};